import React from 'react';
import { Container, Row, Col, Card, Button, } from 'react-bootstrap';
import { useParams, useNavigate } from 'react-router-dom';
import ShopifyHeader from '../ShopifyHeader';

const Settings = () => {
    const { shop } = useParams();
    const navigate = useNavigate();

    const settingsOptions = [
        {
            id: 'categories',
            title: 'Product Categories',
            description: 'Manage MELI product categories and markup settings',
            icon: 'fas fa-tags',
            color: 'primary',
            path: `/shopify/${shop}/settings/categories`
        },
        {
            id: 'pricing',
            title: 'Pricing Settings',
            description: 'Configure pricing rules and markup percentages',
            icon: 'fas fa-dollar-sign',
            color: 'success',
            path: `/shopify/${shop}/settings/pricing`
        },
        {
            id: 'sync',
            title: 'Sync Settings',
            description: 'Configure product synchronization preferences',
            icon: 'fas fa-sync-alt',
            color: 'info',
            path: `/shopify/${shop}/settings/sync`
        },
        {
            id: 'marketplaces',
            title: 'Marketplace Settings',
            description: 'Manage marketplace publishing preferences',
            icon: 'fas fa-globe',
            color: 'warning',
            path: `/shopify/${shop}/settings/marketplaces`
        }
    ];

    return (
        <div style={{ minHeight: '100vh' }}>
            <ShopifyHeader />

            <Container className="py-4">
                <Row>
                    <Col>
                        <div className="d-flex justify-content-between align-items-center mb-4">
                            <div>
                                <h2>Settings</h2>
                                <p className="text-muted">Configure your ALANI360 integration settings</p>
                            </div>
                            <Button
                                variant="outline-secondary"
                                onClick={() => navigate(`/shopify/${shop}/dashboard`)}
                            >
                                <i className="fas fa-arrow-left me-2"></i>
                                Back to Dashboard
                            </Button>
                        </div>
                    </Col>
                </Row>

                <Row className="g-4">
                    {settingsOptions.map((option) => (
                        <Col md={6} lg={4} key={option.id}>
                            <Card className="h-100 settings-card">
                                <Card.Body className="text-center">
                                    <div className={`settings-icon ${option.color}`}>
                                        <i className={`${option.icon} fa-2x`}></i>
                                    </div>
                                    <h5 className="mt-3">{option.title}</h5>
                                    <p className="text-muted">{option.description}</p>
                                    <Button
                                        variant={option.color}
                                        className="w-100"
                                        onClick={() => navigate(option.path)}
                                    >
                                        Configure
                                    </Button>
                                </Card.Body>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </Container>

            <style jsx>{`
                .settings-card {
                    transition: transform 0.2s ease-in-out;
                    border: 1px solid #e9ecef;
                }
                
                .settings-card:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 4px 8px rgba(0,0,0,0.1);
                }
                
                .settings-icon {
                    width: 60px;
                    height: 60px;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin: 0 auto;
                }
                
                .settings-icon.primary {
                    background-color: rgba(13, 110, 253, 0.1);
                    color: #0d6efd;
                }
                
                .settings-icon.success {
                    background-color: rgba(25, 135, 84, 0.1);
                    color: #198754;
                }
                
                .settings-icon.info {
                    background-color: rgba(13, 202, 240, 0.1);
                    color: #0dcaf0;
                }
                
                .settings-icon.warning {
                    background-color: rgba(255, 193, 7, 0.1);
                    color: #ffc107;
                }
            `}</style>
        </div>
    );
};

export default Settings;
